import { Grid } from '@mui/material';
import IReadOnlyField from '../../../components/text-component/readonly-field/i-readonlyfield.component';
import { getSpecList, isNotEmptyArray } from '../../common/util.services';
import './specs.component.scss';
import { SpecProps } from './specs.mapping';
import { useEffect, useState } from 'react';

const SpecsComponent = (props: SpecProps) => {
  const [specList, setSpecList] = useState<any>([]);
  
  useEffect(() => {
    setSpecList(getSpecList(props.data));
  }, []);

  return <Grid container spacing={1}>
    <Grid xs={6}>
      <IReadOnlyField value={props.data.description} label='Description' />
    </Grid>
    <Grid xs={6}>
      <IReadOnlyField value={props.data.supplier} label='Supplier' />
    </Grid>
    {isNotEmptyArray(specList) && specList.map((spec: any) => {
      return <Grid xs={6}><IReadOnlyField value={props.data[spec.fieldObject]} label={spec.fieldName} /> </Grid>
    })}
    <Grid xs={6}>
      <IReadOnlyField value={props.data.sku} label='SKU' />
    </Grid>
    <Grid xs={6}>
      <IReadOnlyField value={props.data.uom} label='UOM' />
    </Grid>
    <Grid xs={6}>
      <IReadOnlyField value={props.data.unitCost} label='Unit Cost' />
    </Grid>
    <Grid xs={6}>
      <IReadOnlyField value={props.data.moq} label='MOQ' />
    </Grid>
    <Grid xs={6}>
      <IReadOnlyField value={props.data.remarks} label='Remarks' />
    </Grid>
  </Grid>
}

export default SpecsComponent;